import React from 'react'
import { useTranslation } from "react-i18next";

const Description = (props) => {
  const { t } = useTranslation();

  return (
    <p className="headerdescription">{t(props.description)}{props.mobileNo ? props.mobileNo : ''}</p>
  )
};

export default Description;